export interface MSLineProps {
    yAxisName?: string,
    numberPrefix?: string,
    dataset?: Series[],
    categories?: Category[],
    width?: string,
    height?: string
    hideLegend?: boolean
    headerLabel?: string
    eventsLegend?: string,
    best?: Series
}

export interface Series {
    seriesname: string,
    anchorBgColor: string,
    anchorBorderColor?: string,
    color: string,
    image?: string,
    alpha?: string,
    isBest?: boolean,
    data: Entry[]
}

export interface Entry {
    value: any
    entityName?: string
    entityImage?: string
}

export interface Category {
    category: CategoryEntry[]
}

export interface CategoryEntry {
    label: string
}

export enum ChartType {
    LINE = 'msline',
    BAR = 'mscolumn2d'
}
